import React from "react";
import { Link } from "react-router-dom";
import Footer from "../components/layout/Footer";

export default function CGU() {
  return (
    <main className="min-h-screen bg-white pt-20 text-gray-900">
      <section className="px-6 pb-4 pt-10">
        <div className="mx-auto max-w-3xl">
          <h1 className="text-4xl font-semibold leading-tight">
            Conditions Générales d&apos;Utilisation
          </h1>
          <p className="mt-3 text-sm text-gray-500">En vigueur au 16/04/2026</p>
        </div>
      </section>

      <section className="px-6 pb-24">
        <div className="mx-auto max-w-3xl space-y-10 text-[15px] leading-7 text-gray-800">
          <p>
            Les présentes conditions générales d&apos;utilisation (ci-après « CGU »)
            ont pour objet de définir les modalités et conditions d&apos;accès et
            d&apos;utilisation du site internet{" "}
            <span className="font-medium">savoinimaux.fr</span> (ci-après « le Site »),
            édité par l&apos;association Savoinimaux, ainsi que les droits et
            obligations de toute personne y accédant (ci-après « l&apos;Utilisateur »).
          </p>

          <p>
            Tout accès au Site implique l&apos;acceptation pleine et entière des
            présentes CGU. Si l&apos;Utilisateur n&apos;accepte pas ces conditions,
            il lui est demandé de ne pas utiliser le Site.
          </p>

          <section>
            <h2 className="mb-3 text-xl font-semibold text-black">
              Article 1 — Éditeur et hébergeur
            </h2>
            <p>Le Site est édité par :</p>
            <ul className="mt-3 list-none space-y-1 pl-0">
              <li>
                <span className="font-medium">Association :</span> SAVOINIMAUX
              </li>
              <li>
                <span className="font-medium">Forme juridique :</span> Association
                régie par la loi du 1er juillet 1901
              </li>
              <li>
                <span className="font-medium">Siège social :</span> 47 Rue du Pont
                Neuf, 74150 Rumilly
              </li>
              <li>
                <span className="font-medium">RNA / Préfecture :</span> Annecy sous
                le n° W741003711
              </li>
              <li>
                <span className="font-medium">SIRET :</span> 794 267 302
              </li>
              <li>
                <span className="font-medium">Directeur de la publication :</span>{" "}
                Stephany Roux
              </li>
              <li>
                <span className="font-medium">Téléphone :</span> +33 (0)6 44 68 52
                53
              </li>
              <li>
                <span className="font-medium">E-mail :</span>{" "}
                <a href="mailto:savoinimaux@gmail.com" className="underline">
                  savoinimaux@gmail.com
                </a>
              </li>
            </ul>

            <p className="mt-4">Le Site est hébergé par :</p>
            <ul className="mt-3 list-none space-y-1 pl-0">
              <li>
                <span className="font-medium">Société :</span> LWS – Ligne Web
                Services
              </li>
              <li>
                <span className="font-medium">Siège social :</span> 4 rue Galvani,
                75017 Paris, France
              </li>
              <li>
                <span className="font-medium">Téléphone :</span> +33 1 77 62 30 03
              </li>
            </ul>

            <p className="mt-3">
              Pour toute information complémentaire, veuillez consulter nos{" "}
              <Link to="/mentions-legales" className="underline">
                Mentions légales
              </Link>
              .
            </p>
          </section>

          <section>
            <h2 className="mb-3 text-xl font-semibold text-black">
              Article 2 — Accès au site
            </h2>
            <p>
              Le Site est accessible gratuitement à tout Utilisateur disposant
              d&apos;un accès à Internet. Tous les coûts liés à cet accès
              (matériel informatique, logiciels, abonnement Internet, etc.) sont à
              la charge exclusive de l&apos;Utilisateur.
            </p>

            <p className="mt-3">
              L&apos;association Savoinimaux se réserve le droit, sans préavis ni
              indemnité, de fermer temporairement ou définitivement l&apos;accès à
              tout ou partie du Site, notamment pour des opérations de maintenance,
              de mise à jour, ou pour toute autre raison technique ou
              organisationnelle. La responsabilité de l&apos;association ne saurait
              être engagée en cas d&apos;indisponibilité du Site, quelle qu&apos;en
              soit la cause.
            </p>

            <p className="mt-3">
              L&apos;Utilisateur s&apos;engage à accéder au Site en utilisant un
              matériel récent, ne contenant pas de virus, et avec un navigateur à
              jour.
            </p>
          </section>

          <section>
            <h2 className="mb-3 text-xl font-semibold text-black">
              Article 3 — Objet du site et services
            </h2>
            <p>
              Le Site a pour objet de présenter l&apos;association Savoinimaux, ses
              actions, ses engagements, ses actualités, ses besoins, ses réseaux et,
              plus largement, toute information utile relative à la protection
              animale en Savoie.
            </p>

            <p className="mt-3">
              Le Site peut également permettre aux Utilisateurs d&apos;entrer en
              contact avec l&apos;association, de suivre ses publications ou
              d&apos;obtenir des informations sur ses activités.
            </p>

            <p className="mt-3">
              L&apos;association Savoinimaux se réserve le droit de modifier,
              compléter ou supprimer, à tout moment et sans préavis, tout ou partie
              des contenus et fonctionnalités du Site.
            </p>
          </section>

          <section>
            <h2 className="mb-3 text-xl font-semibold text-black">
              Article 4 — Propriété intellectuelle
            </h2>
            <p>
              L&apos;ensemble des éléments du Site (textes, images, photographies,
              graphismes, logos, vidéos, structure, charte graphique, éléments
              visuels, etc.) est la propriété exclusive de Savoinimaux ou de ses
              partenaires, et est protégé par les dispositions du Code de la
              propriété intellectuelle.
            </p>

            <p className="mt-3">
              Toute reproduction, représentation, diffusion, commercialisation ou
              modification, totale ou partielle, de ces éléments sans
              l&apos;autorisation expresse et préalable de Savoinimaux est
              strictement interdite et peut constituer une contrefaçon.
            </p>

            <p className="mt-3">
              L&apos;Utilisateur est autorisé à visualiser les contenus du Site pour
              un usage strictement personnel, privé et non commercial. Toute autre
              utilisation est soumise à autorisation préalable et écrite de
              l&apos;association.
            </p>
          </section>

          <section>
            <h2 className="mb-3 text-xl font-semibold text-black">
              Article 5 — Responsabilité de l&apos;Utilisateur
            </h2>
            <p>
              L&apos;Utilisateur est seul responsable de l&apos;usage qu&apos;il
              fait du Site et de ses contenus. Il s&apos;engage à :
            </p>

            <ul className="mt-2 ml-5 list-disc space-y-1">
              <li>
                Ne pas utiliser le Site à des fins illicites, frauduleuses ou
                portant atteinte aux droits de tiers ;
              </li>
              <li>
                Ne pas diffuser de contenus illégaux, diffamatoires, injurieux, ou
                portant atteinte à la vie privée ;
              </li>
              <li>
                Ne pas tenter de perturber ou d&apos;altérer le bon fonctionnement du
                Site ;
              </li>
              <li>
                Respecter les droits de propriété intellectuelle de Savoinimaux et
                des tiers ;
              </li>
              <li>
                Fournir des informations exactes et à jour lorsqu&apos;il complète un
                formulaire sur le Site.
              </li>
            </ul>

            <p className="mt-3">
              En cas de manquement à ces obligations, l&apos;association Savoinimaux
              se réserve le droit de prendre toute mesure appropriée, y compris le
              blocage de l&apos;accès au Site, et d&apos;engager toute action utile.
            </p>
          </section>

          <section>
            <h2 className="mb-3 text-xl font-semibold text-black">
              Article 6 — Responsabilité de Savoinimaux
            </h2>
            <p>
              Les informations publiées sur le Site sont fournies à titre purement
              indicatif. L&apos;association s&apos;efforce de maintenir ces
              informations à jour mais ne garantit pas leur exactitude, exhaustivité
              ou actualité.
            </p>

            <p className="mt-3">Savoinimaux ne saurait être tenue responsable :</p>
            <ul className="mt-2 ml-5 list-disc space-y-1">
              <li>
                Des dommages directs ou indirects résultant de l&apos;utilisation ou
                de l&apos;impossibilité d&apos;utiliser le Site ;
              </li>
              <li>Des erreurs ou omissions dans les contenus publiés ;</li>
              <li>Des pertes de données ou de préjudices indirects ;</li>
              <li>
                Des dommages causés au matériel de l&apos;Utilisateur lors de
                l&apos;accès au Site ;
              </li>
              <li>Des actes ou omissions de tiers.</li>
            </ul>

            <p className="mt-3">
              La responsabilité de l&apos;association ne pourra pas davantage être
              engagée en cas de force majeure.
            </p>
          </section>

          <section>
            <h2 className="mb-3 text-xl font-semibold text-black">
              Article 7 — Liens hypertextes
            </h2>
            <p>
              Le Site peut contenir des liens vers des sites tiers. Ces liens sont
              fournis à titre indicatif. Savoinimaux n&apos;exerce aucun contrôle sur
              ces sites et ne saurait être tenue responsable de leur contenu, de
              leurs pratiques en matière de données personnelles ou de leur
              accessibilité.
            </p>

            <p className="mt-3">
              La mise en place de liens hypertextes pointant vers le Site est
              autorisée sous réserve qu&apos;ils ne portent pas atteinte à l&apos;image
              de l&apos;association, n&apos;induisent pas de confusion sur
              l&apos;origine des contenus et ne constituent pas un usage abusif. Tout
              lien de type frame ou framing est interdit sauf accord écrit préalable.
            </p>
          </section>

          <section>
            <h2 className="mb-3 text-xl font-semibold text-black">
              Article 8 — Cookies
            </h2>
            <p>
              Lors de la consultation du Site, des cookies peuvent être déposés sur
              le terminal de l&apos;Utilisateur. Un cookie est un fichier texte de
              petite taille enregistré sur l&apos;appareil lors de la visite d&apos;un
              site internet.
            </p>

            <p className="mt-3">
              Les cookies utilisés sur le Site peuvent avoir les finalités
              suivantes :
            </p>

            <ul className="mt-2 ml-5 list-disc space-y-1">
              <li>
                <span className="font-medium">Cookies nécessaires :</span>{" "}
                indispensables au bon fonctionnement du Site et à la mémorisation
                des préférences de consentement ;
              </li>
              <li>
                <span className="font-medium">Cookies de mesure d&apos;audience :</span>{" "}
                permettant d&apos;analyser la fréquentation du Site et d&apos;en
                améliorer les performances, sous réserve du consentement de
                l&apos;Utilisateur lorsque celui-ci est requis ;
              </li>
              <li>
                <span className="font-medium">Cookies liés à des contenus externes :</span>{" "}
                permettant l&apos;affichage de certains contenus intégrés, sous
                réserve du consentement de l&apos;Utilisateur lorsque celui-ci est
                requis.
              </li>
            </ul>

            <p className="mt-3">
              L&apos;Utilisateur peut à tout moment modifier ses préférences via
              l&apos;outil de gestion des cookies disponible sur le Site.
            </p>

            <p className="mt-3">
              Pour en savoir plus, veuillez consulter notre{" "}
              <Link to="/politique-cookies" className="underline">
                Politique de cookies
              </Link>
              .
            </p>
          </section>

          <section>
            <h2 className="mb-3 text-xl font-semibold text-black">
              Article 9 — Données personnelles
            </h2>
            <p>
              Savoinimaux traite les données personnelles des Utilisateurs dans le
              strict respect du Règlement (UE) 2016/679 (RGPD) et de la loi n°
              78-17 du 6 janvier 1978 modifiée.
            </p>

            <p className="mt-3">
              Les données collectées via les formulaires du Site sont utilisées
              exclusivement pour répondre aux demandes des Utilisateurs, assurer le
              suivi des échanges, et, le cas échéant, diffuser des informations
              associatives lorsque cela est pertinent et licite.
            </p>

            <p className="mt-3">
              L&apos;association s&apos;engage à ne jamais vendre, louer ou céder les
              données personnelles à des tiers sans base légale appropriée.
            </p>

            <p className="mt-3">
              Pour plus d&apos;informations et pour exercer vos droits (accès,
              rectification, effacement, opposition, limitation), veuillez consulter
              notre{" "}
              <Link to="/politique-de-confidentialite" className="underline">
                Politique de confidentialité
              </Link>{" "}
              ou contacter Savoinimaux à l&apos;adresse :{" "}
              <a href="mailto:savoinimaux@gmail.com" className="underline">
                savoinimaux@gmail.com
              </a>
              .
            </p>
          </section>

          <section>
            <h2 className="mb-3 text-xl font-semibold text-black">
              Article 10 — Sécurité
            </h2>
            <p>
              Savoinimaux met en œuvre les mesures techniques et organisationnelles
              appropriées pour assurer la sécurité du Site et des données transmises
              par les Utilisateurs, notamment contre l&apos;accès non autorisé, la
              modification, la divulgation ou la destruction de données.
            </p>

            <p className="mt-3">
              Toutefois, aucun système de transmission ou de stockage de données sur
              Internet ne peut être garanti comme étant totalement sécurisé.
            </p>
          </section>

          <section>
            <h2 className="mb-3 text-xl font-semibold text-black">
              Article 11 — Modification des CGU
            </h2>
            <p>
              Savoinimaux se réserve le droit de modifier les présentes CGU à tout
              moment, notamment pour se conformer à toute évolution légale,
              réglementaire, jurisprudentielle ou technique.
            </p>

            <p className="mt-3">
              Les CGU applicables sont celles en vigueur au moment de la connexion de
              l&apos;Utilisateur. La poursuite de l&apos;utilisation du Site après
              modification vaut acceptation des nouvelles CGU.
            </p>
          </section>

          <section>
            <h2 className="mb-3 text-xl font-semibold text-black">
              Article 12 — Droit applicable et règlement des litiges
            </h2>
            <p>
              Les présentes CGU sont soumises au droit français, à
              l&apos;exclusion de tout autre droit.
            </p>

            <p className="mt-3">
              En cas de litige relatif à l&apos;interprétation ou à l&apos;exécution
              des présentes CGU, les parties s&apos;engagent à rechercher une
              solution amiable préalable.
            </p>

            <p className="mt-3">
              À défaut d'accord amiable, le litige sera porté devant les
              juridictions françaises compétentes, sauf règles impératives contraires
              applicables.
            </p>
          </section>
        </div>
      </section>

      <Footer />
    </main>
  );
}